import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Star } from "lucide-react";

function TestimonialSection() {
const testimonials = [
  {
    name: "Arun",
    role: "WhatNxt - Founder",
    message:
      "Amazing experience working with the team. The website performance and design quality exceeded expectations.",
    rating: 5,
  },
  {
    name: "Mohit",
    role: "MediaWifi - CEO",
    message:
      "Highly professional team. Delivered our marketing platform on time with excellent UI and speed optimization.",
    rating: 5,
  },
  {
    name: "T J Shivjith",
     role: "Electronics Business Owner",
    message:
      "Very smooth experience. Great communication and perfect execution of our business website.",
    rating: 5,
  },

  {
    name: "Shubham Sharma",
    role: "Real Estate Consultant",
    message:
      "Excellent design and lead generation system. Our real estate inquiries increased significantly.",
    rating: 5,
  },
  {
    name: "Parihar Engineers",
    role: "Renewable Energy Brand",
    message:
      "Very professional development work. Strong technical execution and timely delivery.",
    rating: 5,
  },
 
  {
    name: "Arihant Mehta",
    role: "Legal Consultant",
    message:
      "Perfect website for our law firm. Clean, professional and trust-building design.",
    rating: 5,
  },
];
  return (
    <section className="relative py-16 px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505]">

      {/* BACKGROUND */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:70px_70px]" />

      <div className="relative z-10 max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 dark:text-white">
            What Our{" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">
              Clients Say
            </span>
          </h2>

          <p className=" myparagraph text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Real feedback from clients who trusted us with their digital growth.
          </p>
        </div>

        {/* SWIPER */}
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
         
          loop={true}
          spaceBetween={25}
          centeredSlides={true}
          slidesPerView={"auto"}
        >

          {testimonials.map((item, index) => (
            <SwiperSlide
              key={index}
              className="!w-[320px] md:!w-[420px]"
            >
              <div className="group p-6 rounded-2xl border border-black/5 dark:border-white/10 bg-white/70 dark:bg-white/5 backdrop-blur-xl hover:-translate-y-2 transition-all duration-300">

                {/* STARS */}
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4 text-yellow-400 fill-yellow-400"
                    />
                  ))}
                </div>

                {/* MESSAGE */}
                <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                  "{item.message}"
                </p>

                {/* USER */}
                <div className="mt-6 flex items-center gap-3">
               

                  <div>
                    <h4 className="text-sm font-bold text-gray-900 dark:text-white">
                      {item.name}
                    </h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      {item.role}
                    </p>
                  </div>
                </div>

              </div>
            </SwiperSlide>
          ))}

        </Swiper>
      </div>
    </section>
  );
}

export default TestimonialSection;